export const dummyPosts = (size) => {
  return new Array(size).fill().map((_, index) => ({
    id: index.toString(),
    topics: index % 2 === 0 ? [`Lorem Ipsum...`] : [`Lorem Picsum...`]
  }))
}
